import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fafbfc]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between h-16">
          <a href="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Altrunic" className="w-8 h-8 object-contain" />
            <span className="text-lg font-bold tracking-tight text-gray-900">Altrunic</span>
          </a>
          <button onClick={() => navigate('/')} className="text-sm font-semibold text-gray-600 hover:text-gray-900">Home</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-8" data-testid="terms-title">Terms of Service</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-600 leading-relaxed">
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">1. Acceptance of Terms</h2>
          <p>By accessing or using Altrunic ("the Platform"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Platform.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">2. Description of Service</h2>
          <p>Altrunic is a corporate giving platform that connects businesses with verified charities. The Platform facilitates donation campaigns, employer matching, employee giving portals, impact tracking, and ESG reporting.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">3. Account Registration</h2>
          <p>You must provide a valid work email address and verify it to create a business account. You are responsible for maintaining the confidentiality of your login credentials. Personal email addresses (Gmail, Yahoo, etc.) are not accepted for business admin accounts.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">4. Donations & Payments</h2>
          <p>All donations are processed through Every.org, a 501(c)(3) nonprofit. Donations are tax-deductible. Every.org charges 0% on bank transfers and 2.2% on credit/debit card transactions. Altrunic applies a 2% platform fee on employer-matched donation amounts to sustain the platform. Donors may optionally include a tip to support Altrunic.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">5. Employer Matching</h2>
          <p>Employer matching is managed by the business admin. Altrunic facilitates tracking and reporting of matched donations but does not guarantee that employer matches will be fulfilled. Businesses are responsible for honoring their matching commitments.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">6. Acceptable Use</h2>
          <p>You may not: use the Platform for fraudulent or illegal purposes; submit false or misleading information; attempt to circumvent security measures; or use automated tools to scrape or abuse the Platform.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">7. Intellectual Property</h2>
          <p>The Platform, including its design, code, and AI-generated content, is the property of Altrunic. You may not copy, modify, or distribute any part of the Platform without written permission.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">8. Limitation of Liability</h2>
          <p>Altrunic is provided "as is" without warranties. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Platform. Our total liability shall not exceed the fees you paid to Altrunic in the preceding 12 months.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">9. Termination</h2>
          <p>We may suspend or terminate your account if you violate these terms. You may delete your account at any time from your profile settings.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">10. Changes to Terms</h2>
          <p>We may update these terms. Continued use after changes constitutes acceptance.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">11. Contact</h2>
          <p>Questions about these terms? Email <a href="mailto:support@altrunic.com" className="text-blue-600 hover:underline">support@altrunic.com</a>.</p>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
